/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState } from 'react';
import { DirectedAcyclicGraphWidget } from '@widgets/directed-acyclic-graph-widget';
import { complexNodes, complexEdges } from './demo';
import {
  KanbanEditMembersModal,
  KanbanEditComplianceModal,
  SupplyChainStepModal,
  KanbanWidget,
  KanbanEditRecipientsModal,
} from '@widgets/supply-chain-step-modal-widget';

const kanbanList = [
  {
    title: 'Attributes',
    listId: '1',
    cards: [],
  },
];
// {
//   title: 'Batch No',
//   attributeType: 'text',
//   isRequired: true,
//   id: '1',
// },
// {
//   title: 'Batch Date',
//   attributeType: 'datepicker',
//   isRequired: true,
//   id: '2',
// },
// {
//   title: 'Batch Expiry',
//   attributeType: 'text',
//   isRequired: false,
//   id: '3',
// },
// {
//   title: 'Batch Location',
//   attributeType: 'text',
//   isRequired: true,
//   id: '4',
// },
const attributeTypeValue = [
  {
    label: 'Text',
    value: 'text',
  },
  {
    label: 'Multiline Text',
    value: 'textarea',
  },
  {
    label: 'Rich Text Editor',
    value: 'htmlEditor',
  },
  {
    label: 'Number',
    value: 'number',
  },
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Password',
    value: 'password',
  },
  {
    label: 'Boolean',
    value: 'bool',
  },
  {
    label: 'Selection',
    value: 'radio',
  },
  {
    label: 'Date',
    value: 'datepicker',
  },
  {
    label: 'DateTime',
    value: 'dateTimePicker',
  },
  {
    label: 'Color Picker',
    value: 'colorPicker',
  },
  {
    label: 'Choose Image Upload',
    value: 'choosePhoto',
  },
  {
    label: 'Image(s) Drop Zone',
    value: 'imageDropZone',
  },
  {
    label: 'File(s) Drop Zone',
    value: 'fileDropZone',
  },
];

export const ContainerComm = () => {
  const [showDynamicModal, setShowDynamicModal] = useState<any>({
    key: null,
    data: null,
  });
  const [cardToShow, setCardToShow] = useState(false);
  const [cardToChangeMembers, setCardToChangeMembers] = useState<any>(null);
  const [cardToChangeCompliance, setCardToChangeCompliance] =
    useState<any>(null);

  const handleTraceStepCB = (payload: any) => {
    console.log('trace step cb ->', payload);
  };
  return (
    <>
      <KanbanWidget
        show={true}
        kanbanList={kanbanList}
        attributeTypeValue={attributeTypeValue}
      />
    </>
  );
};
